import { Status, type Customer } from '@/data/types';
import { deriveNextInspection } from '@/lib/customer-dates';

const DAY = 86_400_000;

type StatusInput = Pick<Customer, 'extinguishers' | 'hoses' | 'nextInspection'>;

// Customer status is derived from its devices' inspection state (client
// feedback item 3 — "status is set automatically according to the status of
// the customer's extinguishers"). No devices → NONE; overdue or never
// scheduled → TODO; due within the reminder window → WAITING; otherwise DONE.
// windowDays mirrors the reminders module default.
export function deriveCustomerStatus(
  c: StatusInput,
  windowDays = 30,
  now: Date = new Date(),
  intervalYears?: number
): Status {
  const deviceCount = (c.extinguishers?.length ?? 0) + (c.hoses?.length ?? 0);
  if (deviceCount === 0) return Status.NONE;

  const next = deriveNextInspection(c, intervalYears);
  if (!next) return Status.TODO;
  const parts = next.split('-');
  if (parts.length !== 3) return Status.TODO;
  const due = Date.UTC(
    Number(parts[0]),
    Number(parts[1]) - 1,
    Number(parts[2])
  );
  if (Number.isNaN(due)) return Status.TODO;

  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const daysUntil = Math.round((due - today) / DAY);
  if (daysUntil < 0) return Status.TODO;
  if (daysUntil <= windowDays) return Status.WAITING;
  return Status.DONE;
}
